import { render, staticRenderFns } from "./ForeignLawyerOffice.vue?vue&type=template&id=1ecec8eb&scoped=true"
import script from "./ForeignLawyerOffice.vue?vue&type=script&lang=js"
export * from "./ForeignLawyerOffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecec8eb",
  null
  
)

export default component.exports